export { default as AdminPage } from "./AdminPage";
